import React from "react";
import { useTheme } from "styled-components";

const News = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.188 7.875a.563.563 0 0 1 .562-.562h5.625a.562.562 0 1 1 0 1.125H6.75a.563.563 0 0 1-.562-.563m.562 2.813h5.625a.562.562 0 1 0 0-1.126H6.75a.563.563 0 1 0 0 1.126M16.313 4.5v8.438a1.687 1.687 0 0 1-1.688 1.687H2.25a1.687 1.687 0 0 1-1.687-1.68V6.188a.563.563 0 0 1 1.125 0v6.75a.562.562 0 1 0 1.125 0V4.5a1.125 1.125 0 0 1 1.124-1.125h11.25A1.125 1.125 0 0 1 16.314 4.5m-1.125 0H3.938v8.438c0 .191-.033.381-.097.562h10.784a.56.56 0 0 0 .563-.562z"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default News;
